// import tmobile from './tmobile';
// import tracelist from './tracelist.json';
import spanlist from './spanlist.json';
// import network from './network.json';
// import evo from './evo.json';
// import EcommSalesDemo from './EcommSalesDemo';
import ReactGridLayoutDemoResponsive from './ReactGridLayoutDemoResponsive.json';
import ReactGridLayoutDemoFixed from './ReactGridLayoutDemoFixed.json';
// import SchemaEvolution from './schemaEvolution.json';
// import singleValueDashboard from './singleValueDashboard.json';
// import SingleValueShowcase from './singleValueShowcase.json';
// import cartesianDashboard from './cartesianDashboard.json';
// import healthBarDashboard from './healthBarDashboard.json';
// import docsExamples from './docsExamples.json';
// import demoExample from './demoExample.json';
// import themeTable from './themeTable.json';
import tableExamples from './tableExamples.json';
import cartesianExamples from './cartesianExamples.json';
import olympics from './olympics';

import fsomon from './fsomon';
import documentation from './documentation';
// import tableSortingAndPaginationExample from './tableSortingAndPaginationExample.json';

// Anzen
import userDetailsViewDashboard from './anzen/userDetailsViewDashboard.json';
import databaseExfiltrationDashboardES from './anzen/databaseExfiltrationDashboardES.json';
import databaseExfiltrationDashboardLS from './anzen/databaseExfiltrationDashboardLS.json';
import tableDetailsViewDashboard from './anzen/tableDetailsViewDashboard.json';
import databaseProviderView from './anzen/databaseProviderView.json';
import databaseProviders from './anzen/databaseProviders.json';
import objectStores from './anzen/objectStores.json';
import unusedPrivilegesDashboard from './anzen/unusedPrivilegesDashboard.json';
import unmaskedColumnsDashboard from './anzen/unmaskedColumnsDashboard.json';
import clientDetailsViewDashboard from './anzen/clientDetailsViewDashboard.json';
import inactiveBucketsDashboard from './anzen/inactiveBucketsDashboard.json';
import s3ObjectStoreDashboard from './anzen/s3ObjectStoreDashboard.json';
import s3DetailsDashboard from './anzen/s3DetailsDashboard.json';
import vulnerabilityDiagnosticDashboard from './anzen/vulnerabilityDiagnosticDashboard.json';
import bucketAlertDashboard from './anzen/bucketAlertDashboard.json';
import unusedTablesDashboard from './anzen/unusedTablesDashboard.json';
import unusedColumnsDashboard from './anzen/unusedColumnsDashboard.json';
import unusedColumnsWrittenOnlyDashboard from './anzen/unusedColumnsWrittenOnlyDashboard.json';
import piiDataDiscoveryDashboard from './anzen/piiDataDiscoveryDashboard.json';

// CSA
import csa from './csaapp';
import csaMainDashboard from './csaapp/csaMainDashboard.json';

// FlowMap
import constelletionGraphExamples from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/constellation/constellationGraphExamples.json';
import basicConstellationGraph from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/constellation/basicConstellationGraph.json';
import oneHopConstellationGraph from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/constellation/oneHopConstellationGraph.json';
import constellationGraphWithParticlesAnimation from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/constellation/constellationGraphWithParticlesAnimation.json';
import constellationGraphWithFocusedNodes from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/constellation/constellationGraphWithFocusedNodes.json';
import dependencyGraphExamples from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/dependency/dependencyGraphExamples.json';
import basicDependencyGraph from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/dependency/basicDependencyGraph.json';
import dependencyGraphWithControls from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/dependency/dependencyGraphWithControls.json';
import dependencyGraphWithParticlesAnimation from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/dependency/dependencyGraphWithParticlesAnimation.json';
import dependencyGraphWithFocusedNodes from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/dependency/dependencyGraphWithFocusedNodes.json';
import dependencyGraphWithHighlightedEntities from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/dependency/dependencyGraphWithHighlightedEntities.json';
import nLevelsDependencyGraph from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/dependency/nLevelsDependencyGraph.json';
import nLevelsDependencyGraphWithHighlightedEntities from '../../templates/solutions/dashify-docs/objects/dashboard/flowmap/dependency/nLevelsDependencyGraphWithHighlightedEntities.json';

// TEST
import inlineDemo from './inlinedemo.json';
import layoutTestElbOverview from './layouttest.elbOverview.json';

export default [
  // DASHUI-4934
  ReactGridLayoutDemoResponsive,
  ReactGridLayoutDemoFixed,

  // DASHUI-4602
  ...fsomon,

  // Anzen
  tableDetailsViewDashboard,
  userDetailsViewDashboard,
  databaseExfiltrationDashboardES,
  databaseExfiltrationDashboardLS,
  databaseProviderView,
  databaseProviders,
  objectStores,
  unusedPrivilegesDashboard,
  unmaskedColumnsDashboard,
  clientDetailsViewDashboard,
  inactiveBucketsDashboard,
  s3ObjectStoreDashboard,
  s3DetailsDashboard,
  vulnerabilityDiagnosticDashboard,
  bucketAlertDashboard,
  unusedTablesDashboard,
  unusedColumnsDashboard,
  unusedColumnsWrittenOnlyDashboard,
  piiDataDiscoveryDashboard,

  // Documentation dashboards
  ...documentation,
  cartesianExamples,

  // Demo dashboards
  spanlist,
  tableExamples,

  // Cisco Secure Application
  ...csa,
  csaMainDashboard,

  // FlowMap
  constelletionGraphExamples,
  basicConstellationGraph,
  oneHopConstellationGraph,
  constellationGraphWithFocusedNodes,
  constellationGraphWithParticlesAnimation,
  dependencyGraphExamples,
  basicDependencyGraph,
  dependencyGraphWithControls,
  dependencyGraphWithHighlightedEntities,
  dependencyGraphWithParticlesAnimation,
  dependencyGraphWithFocusedNodes,
  nLevelsDependencyGraph,
  nLevelsDependencyGraphWithHighlightedEntities,

  // test
  inlineDemo,
  layoutTestElbOverview,

  //paris 2024 olympics
  ...olympics,
];
